import React from 'react';
import { object } from 'prop-types';
import { Button, Icon } from '@fiverr-private/fit';
import { r_paper_plane } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import ContactTrigger from '../../shared/ContactTrigger';
import { reportContactSellerClick } from '../../../utils/contactSeller';

import './style.scss';

const ContactExpert = (props, { biEvents, general }) => {
    const reportContactExpertClick = () =>
        reportContactSellerClick({
            biEvents,
            general,
            mixpanelSourceComponent: 'Gig page business seller card',
            bqSourceName: 'expert_card',
            metricKey: 'contact_me.click'
        });

    return (
        <ContactTrigger onClick={reportContactExpertClick}
            className="btn-contact-expert"
            buttonColor={Button.COLORS.LIGHT_GREY}>
            <span className="flex flex-justify-center">
                <Icon className="paper-plane" color={grey_1100}>{r_paper_plane}</Icon>
                <I18n k={'gig_page_perseus.seller_card.contact_me'}/>
            </span>
        </ContactTrigger>
    );
};

ContactExpert.contextTypes = {
    biEvents: object,
    general: object
};

export default ContactExpert;
